import {useEffect,useState} from 'react';
/** Retain a dismissed surface briefly so its exit transition can finish. */
export function useMotionPresence<T>(value:T|null,duration=240){
 const [retained,setRetained]=useState<T|null>(value);
 useEffect(()=>{
  if(value!==null){setRetained(value);return;}
  const reduce=typeof matchMedia==='function'&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timer=setTimeout(()=>setRetained(null),reduce?0:duration);
  return()=>clearTimeout(timer);
 },[value,duration]);
 return {value:value??retained,closing:value===null&&retained!==null};
}
